<script setup lang="ts">
import type { Ratings } from '#shared/interfaces/model-grade/ratings'
import type { Reviews } from '#shared/interfaces/model-grade/reviews'
import { TRANSITION_SOURCE } from '#shared/constant/constant'
import type { SendNewcarSearch } from '@/interfaces/searchUsedCar'
import { postWindowBridge } from '@/utils/windowBridge'

const {
  brandAndCarNameEng,
  ratingsItem = undefined,
  reviewItem = undefined,
  resTotal,
  currentModelFlg = undefined,
  transitionGradeListFlg,
} = defineProps<{
  brandAndCarNameEng: string
  ratingsItem?: Ratings
  reviewItem?: Reviews
  resTotal: number
  currentModelFlg?: boolean
  transitionGradeListFlg: boolean
}>()

const config = useRuntimeConfig()
const nuxtApp = useNuxtApp()
const query = useRoute().query

const openGooNetCarReviwe = () => {
  if (transitionGradeListFlg) {
    const eventName = currentModelFlg
      ? 'CatalogCurrentGradeDetailReviewMoreTap'
      : 'CatalogPastGradeDetailReviewMoreTap'
    nuxtApp.$sendEventGaTag(eventName)
  } else {
    const eventName = currentModelFlg
      ? 'CatalogCurrentMdlTopCarReviewMoreTap'
      : 'CatalogPastMdlTopCarReviewMoreTap'
    nuxtApp.$sendEventGaTag(eventName)
  }

  const url = `${config.public.WEB_REVIEW_URL}${brandAndCarNameEng}/car_review/`
  if (query.transition_source === TRANSITION_SOURCE.newcar_search) {
    const sendNewcarSearch: SendNewcarSearch = {
      url: url,
    }
    if (
      postWindowBridge('transitionCatalogApp', JSON.stringify(sendNewcarSearch))
    )
      return
  }
  window.location.href = url
}
</script>
<template>
  <div v-if="ratingsItem" class="review" style="margin-bottom: 24pt">
    <div class="container">
      <div class="title">車種レビュー</div>
    </div>
    <div
      class="shadow-sm review-cassette"
      style="background-color: white; margin-top: 10px"
    >
      <CardGradeDetailReviewChart
        :average-rating="ratingsItem.average_rating"
        :review-count="ratingsItem.review_count"
        :exterior-design-rating="ratingsItem.exterior_design_rating"
        :interior-design-rating="ratingsItem.interior_design_rating"
        :road-ability-rating="ratingsItem.road_ability_rating"
        :economic-rating="ratingsItem.economic_rating"
        :comfort-rating="ratingsItem.comfort_rating"
        :equipment-rating="ratingsItem.equipment_rating"
        :price-rating="ratingsItem.price_rating"
      />
    </div>
  </div>
  <div v-if="reviewItem" style="padding: 0pt">
    <div class="review-list">
      <CardGradeDetailReviewCard :review="reviewItem" />
    </div>
    <div v-if="resTotal >= 2" class="button-area">
      <div
        class="btn-more-review shadow-sm rounded"
        @click="openGooNetCarReviwe()"
      >
        <div class="btn-content">
          <div class="btn-next">
            車種レビューをもっと見る<span style="font-weight: 300">
              ({{ resTotal + '件' }})</span
            >
          </div>
          <div>
            <img src="@/assets/image/icon/arrow_right.svg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.review {
  margin-top: 48px;
  margin-bottom: 24px !important;
}
.review .title {
  font-size: 20px;
  color: #000000;
  font-weight: bold;
}
.button-area {
  margin: 16px 16px 48px 16px;
}
.btn-more-review {
  display: flex;
  font-size: 12px;
  font-weight: bold;
  min-height: 38px;
  width: 100%;
  background: #ffffff;
}
.btn-content {
  display: flex;
  margin: 0 0 0 22%;
  align-items: center;
}
.btn-next {
  margin-right: 50px;
}
a .btn-more-review {
  color: #000000;
}
.btn-more-review i {
  float: right;
  color: red;
}
.review-cassette {
  height: auto;
}
</style>
